import React from 'react';
import FormularioContacto from '../components/formularios/FormularioContacto';

function Contacto() {
  return (
    <main className="w-full p-0 m-0 flex flex-col items-center content-center overflow-hidden relative">
      <div className="w-full group h-32 md:h-56 p-6 flex justify-center items-end bg-gray-900 relative overflow-hidden">
        <h1 className="z-10 text-xl sm:text-2xl md:text-4xl lg:text-5xl font-extrabold text-white font-sans group-hover:-translate-y-3 transition duration-500 ease-in-out">
          CONTÁCTANOS
        </h1>
        <img
          src="https://img-cdn.hytera.com/iwov-resources/hytera/02_products/11_landing_page/en_subpage_banner_DMR_Radios.jpg_n.webp"
          alt="Banner Andes-TEC"
          className="object-cover w-full h-full absolute top-0 left-0 right-0 bottom-0 z-0"
        />
        <div className="absolute top-0 left-0 right-0 bottom-0 z-0 bg-purple-950 opacity-70" />
      </div>

      <div className="mapa relative h-56 w-full overflow-hidden border">
        <iframe
          title="Mapa de ubicación de nuestra oficina en Providencia"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3261.363284775294!2d-70.61657350234262!3d-33.42607573155116!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cf63905aaaab%3A0x2bb2f0323592d648!2sPadre%20Mariano%2082%2C%20Oficina%20503%2C%207500026%20Providencia%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses-419!2scl!4v1749766169657!5m2!1ses-419!2scl"
          width="600"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="w-full h-full"
        />
      </div>

      <div className="w-full flex flex-col md:flex-row content-center justify-start p-10 items-start overflow-hidden">
        <div>
          <h2 className="uppercase text-purple-900 font-extrabold text-xl border-l-4 pl-4 border-purple-800 my-4">
            Nuestras redes de contacto
          </h2>
          <p className="text-gray-700 text-sm md:text-base my-2">
            En Andes-TEC nos especializamos en soluciones de radiocomunicación profesional, y estamos aquí para ayudarte a encontrar el equipo ideal para tus necesidades. Contáctanos a través de los siguientes medios:
          </p>
        </div>
        <div className="md:pl-10 grid grid-cols-2 gap-4 md:flex md:flex-wrap">
          <a
            href="mailto:ventas@andes-tec.cl"
            target="_blank"
            rel="noreferrer"
            className="flex content-center items-center text-xl font-semibold text-purple-900 px-4 cursor-pointer border-white hover:border-purple-800 hover:scale-105 transition duration-500 rounded-md border-4 shadow-md py-2 md:mx-4 md:my-4"
          >
            <ion-icon
              className="text-4xl text-purple-800 hover:text-purple-700 transition-colors duration-300 ease-in-out"
              name="mail-outline"
            />
            <div className="flex flex-col">
              <span className="ml-2">Correo</span>
              <span className="ml-2 text-xs text-gray-500">
                ventas@andes-tec.cl
              </span>
            </div>
          </a>

          <div
            id="phone-link"
            className="flex content-center items-center text-xl font-semibold text-purple-900 px-4 cursor-pointer border-white hover:border-purple-800 hover:scale-105 transition duration-500 rounded-md border-4 shadow-md py-2 md:mx-4 md:my-4"
          >
            <ion-icon
              className="text-4xl text-purple-800 hover:text-purple-700 transition-colors duration-300 ease-in-out"
              name="call-outline"
            />
            <div className="flex flex-col">
              <span className="ml-2">Teléfono</span>
              <span className="ml-2 text-xs text-gray-500">
                +56 2 2247 8223
              </span>
            </div>
          </div>

          <a
            href="https://www.google.com/maps/place/Padre+Mariano+82,+Oficina+503,+7500026+Providencia,+Regi%C3%B3n+Metropolitana/@-33.4261001,-70.6166138,17z/data=!3m1!4b1!4m6!3m5!1s0x9662cf63905aaaab:0x2bb2f0323592d648!8m2!3d-33.4261001!4d-70.6166138!16s%2Fg%2F11kpdjn75m?entry=ttu&g_ep=EgoyMDI1MDYwOS4xIKXMDSoASAFQAw%3D%3D"
            rel="noreferrer"
            target="_blank"
            className="flex content-center items-center text-xl font-semibold text-purple-900 px-4 cursor-pointer border-white hover:border-purple-800 hover:scale-105 transition duration-500 rounded-md border-4 shadow-md py-2 md:mx-4 md:my-4"
          >
            <ion-icon
              className="text-4xl text-purple-800 hover:text-purple-700 transition-colors duration-300 ease-in-out"
              name="location-outline"
            />
            <div className="flex flex-col">
              <span className="ml-2">Dirección</span>
              <span className="ml-2 text-xs text-gray-500">
                Padre Mariano 82 oficina 503, Providencia, Región Metropolitana
              </span>
            </div>
          </a>
        </div>
      </div>

      <div className="px-10 pb-10 w-full relative">
        <div className="p-6 mt-4 border-4 border-gray-100 hover:border-gray-200 rounded-md hover:shadow-lg overflow-hidden transition duration-500 relative z-10 bg-purple-950 bg-opacity-90">
          <h3 className="font-extrabold text-start md:text-xl text-white uppercase relative z-10">
            Formulario de contacto
          </h3>
          <p className="text-start text-sm md:text-base text-gray-200 my-3 relative z-10 font-semibold">
            ¿Tienes preguntas sobre productos Hytera o proyectos de radiocomunicación? Llena este formulario y uno de nuestros especialistas se pondrá en contacto contigo lo antes posible.
          </p>
          <div className="w-full relative z-10">
            <FormularioContacto />
          </div>
          <img
            src="https://dps2wxsijib8x.cloudfront.net/atst/BannerContacto.png"
            alt="Banner Andes-TEC"
            className="object-cover w-full h-full absolute top-0 left-0 right-0 bottom-0 z-0 opacity-35"
          />
        </div>
      </div>
    </main>
  );
}

export default Contacto;
